import React from "react";
import { connect } from "react-redux";
import BackIcon from "../../assets/img/backIcon";
import { increaseMapLevel } from "../../redux/map/map.actions";
import { MapForwardBtnStyled } from "./mapForwardBtn.styles";

const MapForwardBtn = ({ increaseMapLevel }) => {
  const handle_backBtn_click = () => {
    increaseMapLevel();
  };

  return (
    <MapForwardBtnStyled className="shadow" onClick={handle_backBtn_click}>
      <div style={{ transform: "rotate(180deg)" }}>
        <BackIcon />
      </div>
    </MapForwardBtnStyled>
  );
};

const mapStateToProps = null;

const mapDispatchToProps = (dispatch) => ({
  increaseMapLevel: () => dispatch(increaseMapLevel()),
});

export default connect(mapStateToProps, mapDispatchToProps)(MapForwardBtn);
